import {
  Button,
  ButtonType,
  ContentBox,
  Modal,
  ModalBodySection,
  ModalBodyWithSections,
  ModalFooter,
  ModalHeader,
  noop,
} from '@chillibean/component-library';
import PropTypes from 'prop-types';

export function MoreDataModal(props) {
  const { data, onClose = noop, visible = false } = props;

  return (
    <Modal onClose={onClose} visible={visible}>
      <ModalHeader closeable onClose={onClose} title="Change Details" />
      <ModalBodyWithSections>
        {data.map((item) => (
          <ModalBodySection key={item.title} title={item.title}>
            <ContentBox data={item.content} withSeparator={item.withSeparator} />
          </ModalBodySection>
        ))}
      </ModalBodyWithSections>
      <ModalFooter>
        <Button onClick={onClose} text="CLOSE" type={ButtonType.TERTIARY} />
      </ModalFooter>
    </Modal>
  );
}

MoreDataModal.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({ content: PropTypes.shape({}), title: PropTypes.string, withSeperator: PropTypes.bool }),
  ).isRequired,
  onClose: PropTypes.func,
  visible: PropTypes.bool,
};

export default MoreDataModal;
